export function ArrowIcon({ className }: { className?: string }) {
  return (
    <svg
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect y="5.00098" width="14" height="2" fill="currentColor" />
      <rect x="11" y="4.00098" width="2" height="2" fill="currentColor" />
      <rect x="9" y="8.00098" width="2" height="2" fill="currentColor" />
      <rect x="8" y="9.00098" width="2" height="2" fill="currentColor" />
      <rect x="7" y="10.001" width="2" height="2" fill="currentColor" />
      <rect x="10" y="3.00098" width="2" height="2" fill="currentColor" />
      <rect x="10" y="7.00098" width="2" height="2" fill="currentColor" />
      <rect x="9" y="2.00098" width="2" height="2" fill="currentColor" />
      <rect x="8" y="1.00098" width="2" height="2" fill="currentColor" />
      <rect x="7" y="0.000976562" width="2" height="2" fill="currentColor" />
      <rect x="11" y="6.00098" width="2" height="2" fill="currentColor" />
    </svg>
  )
}
